import { BUY_NOW_FLOW_QUERY_PARAM, DEVICE_TYPE, PAGE_NAMES } from "../../../constants";
import { CLIENT_URLS } from "constants/urls";
import { shouldAppendBuyNowApiParam } from "helpers/utils/buyNowCheckoutFlow";
import { appendQueryStringToUrl } from "helpers/utils/url";
import { trackPaymentMethodClick } from "layouts/Payment/common/dependencies/tracking";


export const getOtherPaymentOptionConfig = (history: any, isGuest: boolean) => {
  return [
    {
      mode: "cards",
      leadIcon:
        "https://adn-static1.nykaa.com/media/wysiwyg/Payments/DesktopRevamp_icons/card-debit-credit-24_2.svg",
      endIcon: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Right.svg",
      label: "Credit/ Debit Card",
      clickHandler: () => {
        trackPaymentMethodClick({
          paymentMethod: "Cards",
          isSaved: false,
          deviceType: DEVICE_TYPE.MOBILE,
          isLoggedIn: !isGuest,
          interactionLocation: PAGE_NAMES.PAYMENT_BOTTOMSHEET
        });
        let redirectionUrl = `${CLIENT_URLS.PAYMENT_BASE_URL}?screen=newPayment&method=cc`;
        if (shouldAppendBuyNowApiParam()) {
          redirectionUrl = appendQueryStringToUrl(redirectionUrl, `${BUY_NOW_FLOW_QUERY_PARAM}=true`);
        }
        history.replace(redirectionUrl);
      },
    },
    {
      mode: "",
      leadIcon: "https://images-static.nykaa.com/media/desktop-icons/Icon.svg",
      endIcon: "https://adn-static1.nykaa.com/media/wysiwyg/Payments/Right.svg",
      label: "Other payment method",
      clickHandler: () => {
        trackPaymentMethodClick({
          paymentMethod: "other_payment_method",
          isSaved: false,
          deviceType: DEVICE_TYPE.MOBILE,
          isLoggedIn: !isGuest,
          interactionLocation: PAGE_NAMES.PAYMENT_BOTTOMSHEET
        });
        let redirectionUrl = `${CLIENT_URLS.PAYMENT_BASE_URL}?screen=newPayment`;
        if (shouldAppendBuyNowApiParam()) {
          redirectionUrl = appendQueryStringToUrl(redirectionUrl, `${BUY_NOW_FLOW_QUERY_PARAM}=true`);
        }
        history.replace(redirectionUrl);
      },
    },
  ];
};
